<template>

  <form v-on:submit="save" action="#" method="post" id="" v-if="user">

    <div class="row">
      <div class="col-xs-7">
        <div class="form-group">
          <label for="profile" class="required">Profile</label>
          <v-select2 id="profile" label="name" :options="profiles" v-model="profileSelected"></v-select2>
        </div>
      </div>
      <div class="col-xs-5" style="margin-top: 20px">
        <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info pull-right" :data-style="submit.dataStyle"> Save Changes </vue-ladda>
      </div>
    </div>
  </form>
</template>

<style scoped>

</style>
<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda, vSelect2},
  name: 'Profile',
  props: ['user'],
  data () {
    return {
      profiles: [],
      profileSelected: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      api_url: process.env.API_URL
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.axios.patch('user/' + this.user.id + '/profile', {
        profile_id: this.profileSelected !== null ? this.profileSelected.id : null
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Profile changed',
          placement: 'bottom-right'
        })
        this.$emit('input', this.profileSelected)
      }).catch((error) => {
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.axios.get('/profiles')
        .then((response) => {
          this.profiles = response.data
        })
        .catch(function (error) {
        })
    }
  },
  beforeMount () {
    if (this.user !== null && typeof this.user.profile !== 'undefined') {
      this.profileSelected = this.user.profile
    }
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Profile.vue